(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-location-name.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-location-name.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  selectedResultAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const ResultDrawLocationName = _ref => {
  let {
    isChild = false
  } = _ref;
  const selectedResult = useAtomValue(selectedResultAtom);
  const suffix = isChild ? '-child' : '';
  return React.createElement("div", {
    className: "lp-draw-location-name-container"
  }, React.createElement("div", {
    className: "lp-draw-location-name".concat(suffix, " gsap-location-name").concat(suffix, " gsap-hide")
  }, selectedResult.location.county));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultDrawLocationName
});

 })(window);